import { Button, Col, Form, Input, message, Row, Select, Steps, Upload } from "antd";
import fileDownload from "js-file-download";
import React, { useEffect } from "react";
import { useSocket } from "@components/SocketProvider";
import { useState } from "react";
import toast from "react-hot-toast";
import webGISService from "@services/web-gis.service";

const { Option } = Select;
const { Dragger } = Upload;
const { Step } = Steps;


/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

let interval = undefined;

const downloadFile = (url) => {
  const e = document.createElement("a");
  e.href = url;
  e.download = url.substr(url.lastIndexOf("/") + 1);
  document.body.appendChild(e);
  e.click();
  document.body.removeChild(e);
};

const Propagation = () => {
  const socket = useSocket();

  const [progress, setProgress] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [legends, setLegends] = useState([]);
  const [form] = Form.useForm();

  const handleFormValuesChange = async (changedValues) => {
    // const formFieldName = Object.keys(changedValues)[0];
  };

  const customRequest = async ({ file, onSuccess, onError, ...info }) => {
    try {
      setTimeout(() => {
        onSuccess(info);
      }, 1000);
    } catch (error) {
      onError(error);
    }
  };

  const onChange = async (info) => {
    const { status } = info.file;
    if (status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (status === "done") {
      // toast.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      toast.error(`${info.file.name} file upload failed.`);
    }
  };

  const onDrop = (e) => {
    console.log("Dropped files", e.dataTransfer.files);
  };

  const onFinish = async ({
    file: {
      file: { originFileObj },
    },
    ...values
  }) => {
    setProgress(0);
    setSubmitted(true);
    try {
      // console.log("file", originFileObj);
      console.log("values", { ...values });

      const formData = new FormData();

      formData.append("file", originFileObj);
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });

      const res = await webGISService.uploadPropagation(formData);

      const contentDisposition = res.headers["content-disposition"];
      const startIndex = contentDisposition.indexOf("filename=") + 10; // Adjust '+ 10' if filename is not the right one.
      const endIndex = contentDisposition.length - 1; //Check if '- 1' is necessary
      const filename = contentDisposition.substring(startIndex, endIndex);

      fileDownload(res.data, filename);
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitted(false);
    }
  };

  const fetchLegendList = async () => {
    try {
      const res = await webGISService.fetchLegendList();
      setLegends(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (submitted) {
      interval = setInterval(() => {
        setProgress((prev) => prev + 1);
      }, 100);
    } else {
      clearInterval(interval);
    }
  }, [submitted]);

  useEffect(() => {
    if (progress === 100) {
      setSubmitted(false);
      clearInterval(interval);
    }
    // eslint-disable-next-line
  }, [progress]);

  useEffect(() => {
    fetchLegendList();

    socket.on("progress", function (data) {
      // console.log("progress", data);
      setProgress(data);
    });

    socket.on("message", function (data) {
      // console.log("message", data);
      if (data.s === 0) {
        setSubmitted(false);
        toast.error(data.message);
      }
    });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="p-5">
      <div className="bg-white rounded-md border border-gray-200 p-5">
        <Form
          form={form}
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
          onValuesChange={handleFormValuesChange}
        >
          <Row gutter={[14, 14]}>
            <Col span={24} sm={12} lg={8}>
              <Form.Item
                label="Legend"
                key="Legend"
                name="legend"
                rules={[{ required: true }]}
              >
                <Select
                  labelInValue={true}
                  showSearch={true}
                  className="w-full"
                >
                  {[...legends].map((item) => (
                    <Option value={item.name}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                name="file"
                label="File"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Dragger
                  multiple={false}
                  onChange={onChange}
                  onDrop={onDrop}
                  maxCount={1}
                  customRequest={customRequest}
                >
                  <div className="flex justify-center text-blue-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-12 w-12"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                      />
                    </svg>
                  </div>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                  <p className="ant-upload-hint">
                    Support for a single or bulk upload. Strictly prohibit from
                    uploading company data or other band files
                  </p>
                </Dragger>
              </Form.Item>
            </Col>

            <Col flex="auto" className="flex justify-end items-end">
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={submitted}
                  className="mt-4"
                >
                  Upload
                </Button>
                <Button
                  style={{ margin: "0 8px" }}
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>


        {submitted && (
          <div className="mt-10">
            <Steps
              percent={progress}
              current={
                progress < 25 ? 0 : progress < 50 ? 1 : progress < 75 ? 2 : 3
              }
              direction="horizontal"
              className="mt-5"
            >
              <Step
                title={progress < 20 ? "In Progress" : "Finished"}
                description="Waiting for server response"
              />
              <Step
                title={
                  progress < 25
                    ? "Waiting"
                    : progress < 50
                    ? "In Progress"
                    : "Finished"
                }
                description="Read from Database"
              />
              <Step
                title={
                  progress < 50
                    ? "Waiting"
                    : progress < 75
                    ? "In Progress"
                    : "Finished"
                }
                description="Create Excel file"
              />
              <Step
                title={
                  progress < 75
                    ? "Waiting"
                    : progress < 100
                    ? "In Progress"
                    : "Finished"
                }
                description="Download"
              />
            </Steps>
          </div>
        )}
      </div>
    </div>
  );
};

export default Propagation;
